(function () {
  'use strict';

  if (customElements.get('footer-wordmark')) return;

  var REFERENCE_SIZE = 100;

  // Sizes the wordmark so its text exactly fills the element's width. The text's width per pixel
  // of font size is measured once at a reference size (again after web fonts load); resizes then
  // only divide, so no layout is read inside the resize loop.
  class FooterWordmark extends HTMLElement {
    connectedCallback() {
      if (this.isConnectedController) return;
      this.isConnectedController = true;
      this.text = this.querySelector('.footer-wordmark__text');
      if (!this.text) return;

      this.measure();
      this.resizeObserver = new ResizeObserver((entries) => this.fit(entries[0].contentRect.width));
      this.resizeObserver.observe(this);
      // The wordmark face is often requested only once this text renders, so re-measure whenever
      // a font finishes loading rather than trusting the status at connect time.
      this.handleFontsLoaded = () => {
        this.measure();
        this.fit(this.clientWidth);
      };
      if (document.fonts) document.fonts.addEventListener('loadingdone', this.handleFontsLoaded);
    }

    disconnectedCallback() {
      if (this.resizeObserver) this.resizeObserver.disconnect();
      if (document.fonts && this.handleFontsLoaded) document.fonts.removeEventListener('loadingdone', this.handleFontsLoaded);
      this.isConnectedController = false;
    }

    measure() {
      this.text.style.fontSize = REFERENCE_SIZE + 'px';
      this.widthPerPixel = this.text.getBoundingClientRect().width / REFERENCE_SIZE;
    }

    fit(width) {
      if (!this.widthPerPixel || !width) return;
      this.text.style.fontSize = (width / this.widthPerPixel).toFixed(2) + 'px';
    }
  }

  customElements.define('footer-wordmark', FooterWordmark);
})();
